import ClaimService from './ClaimService';
export default ClaimService;
